export default "__VITE_ASSET__DWNUA8Nx__"